
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyListitem as SkyListitemElement, SkyListitemActivateDetail } from '@sky.ui/core/sky-listitem';
 
 

 
 export const SkyListitem = createComponent({
   displayName: 'SkyListitem',
   react: React,
   tagName: 'sky-listitem',
   elementClass: SkyListitemElement,
   events: {
     
     onItemActivate: 'item-activate' as EventName<CustomEvent<SkyListitemActivateDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-listitem';
